import { LoadDistrictsByDescription } from 'domain/usecases/address/load-districts-by-description'
import { AddressRepository } from 'repository/interfaces/address-repository'

export class RemoteLoadDistrictsByDescription
  implements LoadDistrictsByDescription
{
  private readonly addressRepository: AddressRepository

  constructor(addressRepository: AddressRepository) {
    this.addressRepository = addressRepository
  }

  load(
    params: LoadDistrictsByDescription.Params
  ): Promise<LoadDistrictsByDescription.Model> {
    return this.addressRepository.loadDistricts(params)
  }
}
